import {
  setOnboardingToken,
  handleAccountHolder,
  handleConfirmation,
  handleJointAccountOwner,
  handleContactsPage,
  handleAddContactPage,
  handleEditContactPage,
  setSecureDocUploaderToken,
} from 'routing/thunks/onboarding'

import * as paths from 'utils/urlPaths'

const routesMap = {
  /* Onboarding */
  ONBOARDING_GETTING_STARTED: {
    path: paths.ONBOARDING_GETTING_STARTED_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_ABOUT_YOU: {
    path: paths.ONBOARDING_ABOUT_YOU_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_PERSONAL_INFORMATION: {
    path: paths.ONBOARDING_PERSONAL_INFORMATION_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_IDENTITY_VERIFICATION: {
    path: paths.ONBOARDING_IDENTITY_VERIFICATION_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_EMPLOYMENT_DETAILS: {
    path: paths.ONBOARDING_EMPLOYMENT_DETAILS_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_YOUR_ACCOUNTS: {
    path: paths.ONBOARDING_YOUR_ACCOUNTS_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_ACCOUNT_DETAILS: {
    path: paths.ONBOARDING_ACCOUNT_DETAILS_PATH,
    thunk: handleJointAccountOwner
  },
  ONBOARDING_EMPLOYER_INFORMATION: {
    path: paths.ONBOARDING_EMPLOYER_INFORMATION_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_ADDITIONAL_DETAILS: {
    path: paths.ONBOARDING_ADDITIONAL_DETAILS_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_JOINT_OWNER: {
    path: paths.ONBOARDING_JOINT_OWNER_PATH,
    thunk: handleJointAccountOwner
  },
  ONBOARDING_ADD_CONTACT: {
    path: paths.ONBOARDING_ADD_CONTACT_PATH,
    thunk: handleAddContactPage
  },
  ONBOARDING_EDIT_CONTACT: {
    path: paths.ONBOARDING_EDIT_CONTACT_PATH,
    thunk: handleEditContactPage
  },
  ONBOARDING_CONTACTS_PAGE: {
    path: paths.ONBOARDING_CONTACTS_PATH,
    thunk: handleContactsPage
  },
  ONBOARDING_REVIEW_AND_SUBMIT: {
    path: paths.ONBOARDING_REVIEW_AND_SUBMIT_PATH,
    thunk: handleAccountHolder
  },
  ONBOARDING_CONFIRMATION: {
    path: paths.ONBOARDING_CONFIRMATION_PATH,
    thunk: handleConfirmation
  },
  ONBOARDING: {
    path: paths.ONBOARDING_TOKEN_PATH,
    thunk: setOnboardingToken
  },
  /* Secure Doc Uploader */
  SECURE_DOC_UPLOADER_PAGE: paths.SECURE_UPLOAD_PATH,
  SECURE_DOC_UPLOADER: {
    path: paths.SECURE_UPLOAD_TOKEN_PATH,
    thunk: setSecureDocUploaderToken
  },
}

export default routesMap



// WEBPACK FOOTER //
// ./src/routing/routesMap/onboarding.js